import {Injectable} from '@angular/core'
import {HttpClient, HttpParams} from '@angular/common/http'
import {environment} from "../../environments/environment";
import {Observable} from 'rxjs'
import {BBResponseContainer} from '../common-services/response-container'
import {SampleReceptionDetailsDto} from './model/sample-reception-details-dto'
import {DirectPrintRequest} from '../print-plate-labels/ngs-print-request';
import {map, timeout} from "rxjs/operators";

@Injectable()
export class NgsSampleArrivalService {

  constructor(private http: HttpClient) {
  }

  getSampleDetails(labId:string, barcode: string, orderNumber: string | undefined): Observable<BBResponseContainer> {
    const url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'reception'
    
    let requestParam = new HttpParams().set('barcode', barcode)
    requestParam = requestParam.append('labId',labId);
    if (orderNumber) {
      requestParam = requestParam.append('orderNumber', orderNumber)
    }
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options);
  }

  saveSampleReceptionDetails(samples: SampleReceptionDetailsDto[]): Observable<BBResponseContainer> {
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL  + 'reception'
    return this.http.post<BBResponseContainer>(url, samples);
  }

  printSampleLabels(printRequest: DirectPrintRequest): Observable<BBResponseContainer> {
    let url = environment.BB_PRINT_SERVICE_URL + 'printLabel'
    return this.http.post<BBResponseContainer>(url, printRequest);
  }

  getSampleDetailsByPlateBarcode(labId: string, plateBarcode: string, orderNumber: string): Observable<SampleReceptionDetailsDto[]>{
    const url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'plate/reception'
    let requestParam = new HttpParams().set('labId', labId).set('plateBarcode', plateBarcode)
    if (orderNumber) {
      requestParam = requestParam.append('orderNumber', orderNumber)
    }
    const options = { params: requestParam } ;
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), map(result=>result.data as SampleReceptionDetailsDto[]));
  }
}
